var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ParticipantsDashboard',{attrs:{"profileId":_vm.profileId,"isCompanyAdmin":_vm.isCompanyAdmin}})}
var staticRenderFns = []

export { render, staticRenderFns }